import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { useHistory, useLocation } from 'react-router-dom';
import Footer from "./AGB/Footer";
import StartPage from "./FirstSteps3/StartPage";
import Routes from './Routes';
import StartpageButton from "./StartpageButton";
  
function SubApp() {
  const history = useHistory();
  const location = useLocation();
  const currentUser = useSelector(st => st.currentUser)
  const loggedIn = !!currentUser.username;
  const globals = useSelector(st => st.globals);

  useEffect(() => {
    const fetch = () => {
      const search = new URLSearchParams(location.search);
      if(search.size === 0)return;
      const next = search.get('next');
      const code = search.get('code');
      const username = search.get('username');
      const email = search.get('email');
      const cruiseId = search.get('cruise_id');
      if(next === "editprofile"){
          if(loggedIn)history.push(`users/${currentUser.username}/profile`);
          return;
        }else if(next === "cruises"){
          history.push(`/cruises/${cruiseId}`);
          return;
        }else if(next === "newpassword"){
          history.push(`/newpassword/${username}/${code}`);
          return;
        }else if(next === "datenschutz"){
          history.push('/datenschutz');
          return;
        }else if(next === "login"){
          history.push('/login')
          return;
        }else if(next === "confirmation"){
          history.push(`/confirmation/${username}/${code}`);
          return
        }else if(next === "unsubscribe"){
          history.push(`unsubscribe/${email}/${code}`);
          return
        }else if(next === "deleteform"){
          history.push('/deleteform')
            return;
        }else if(next === "delete"){
          history.push(`/delete/${username}/${email}/${code}`);
          return;
        }else if (loggedIn){
          history.push('/home')
          return;
        }else{
          return null;
        };
    }
    fetch();
  }, [history, loggedIn, globals, currentUser, location]);

  return (
    <div id="idSubApp" style={{minWidth:"100%"}}>
      {loggedIn && <StartPage/>}
      {!loggedIn && <><StartPage/><StartpageButton/></>}
      <Routes/>
      <Footer className='footer sticky'/>
    </div>
  );
}

export default SubApp;